// Configuración centralizada de APIs y URLs del servidor
export const API_CONFIG = {
  // URL base del servidor de procesamiento
  PROCESSING_SERVER_URL: 'https://seal-app-milhk.ondigitalocean.app',

  // URL base del servidor de WhatsApp/WAHA
  WHATSAPP_SERVER_URL: 'https://jellyfish-app-taaoh.ondigitalocean.app',

  // API Key para autenticación
  API_KEY: '74d3d906-acd4-4702-bfef-5bcc3482a292',

  // URLs específicas de endpoints
  ENDPOINTS: {
    // Dashboard stats
    DASHBOARD_STATS: '/api/stats/dashboard',

    // Send text messages
    SEND_TEXT: '/sendText',

    // Hangfire dashboard (external)
    HANGFIRE_DASHBOARD: 'https://seal-app-milhk.ondigitalocean.app/hangfire/',

    // WhatsApp Engine dashboard (external)
    WHATSAPP_ENGINE_DASHBOARD: 'https://jellyfish-app-taaoh.ondigitalocean.app/dashboard/'
  }
}

// Función helper para construir URLs completas
export const buildApiUrl = (endpoint, params = {}) => {
  const baseUrl = API_CONFIG.PROCESSING_SERVER_URL
  let url = `${baseUrl}${endpoint}`
  
  // Agregar parámetros de consulta si existen
  const queryParams = new URLSearchParams(params)
  if (queryParams.toString()) {
    url += `?${queryParams.toString()}`
  }
  
  return url
}

// Función helper para obtener headers de autenticación
export const getAuthHeaders = () => ({
  'X-Api-Key': API_CONFIG.API_KEY
})

export default API_CONFIG

